/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".qr-code-modal.sc-ion-modal[_ngcontent-%COMP%], .qr-code-modal.sc-ion-modal-md-h[_ngcontent-%COMP%]{height:700px;--height:800px}"];
export { styles as styles };
